export default __webpack_public_path__ + "static/media/HamburgerMenu.b6f9cda4.svg";